<div class="m-r-0 fuse-card auto-width mb-12 mat-card mat-elevation-z2 schedular-card"
    [ngClass.gt-sm]="'mb-0 mr-12 p-0'">
    <div class="p-10 h-30" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="pr-10" [innerHTML]="theHtmlString" id="addr" *ngIf="address" (ngModel)=address></div>
        <div class="p-12" fxLayout="row">
        <button type="button" *ngIf ="showDownload" class="edit mat-raised-button mat-button-base ng-star-inserted line-excel" 
        (click)="openCalendarDialog()">Descargar calendario anterior</button>
        </div>
    </div>
    <div class="p-10 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
        <div id='scheduler-calendar'></div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
        <div fxFlex="100" fxFlex.gt-sm="50" class="example-container p-10 m-h-130 title-clr" *ngIf="address">
            <div class="w-100p"><span>Empresa: </span>{{address.empresa}}</div>
            <div class="w-100p"><span>Centro: </span>{{address.nombrecentro}}</div>
            <div class="w-100p"><span>Med. Ref.: </span>{{address.medicoreferencia}}</div>
            <div class="w-100p"><span>Dirección: </span>{{address.direccion}}</div>
            <div class="w-100p"><span>C. Postal: </span>{{address.cp}}</div>
            <div class="w-100p"><span>Teléfono: </span>{{address.telefono}}</div>
            <div class="w-100p"><span>Poblacion: </span>{{address.poblacion}}</div>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" class="example-container p-10 m-h-130 title-clr" *ngIf="address">
            <div class="w-100p"><span>Observaciones del Calendario: </span>{{comment}}</div>
        </div>
    </div>
</div>